import { ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2, signal } from '@angular/core';
import { IframeQueueService } from '../iframe-queue.service';
import { IframeComponent } from '../iframe/iframe.component';

@Component({
    selector: 'app-iframe-wrapper',
    templateUrl: './iframe-wrapper.component.html',
    imports: [IframeComponent]
})
export class IframeWrapperComponent implements OnInit, OnDestroy {
    iframeUrl = signal('');

    listener?: () => void;
    timeoutId: ReturnType<typeof setTimeout> | number | null = null;

    constructor(
        private iframeQueueService: IframeQueueService,
        private renderer: Renderer2,
        private changeDetectorRef: ChangeDetectorRef
    ) { }

    ngOnDestroy(): void {
        if (this.listener) {
            this.listener();
        }
    }

    ngOnInit(): void {
        this.iframeQueueService.listenForIframeQueueInEvent().subscribe((nextUrl) => {
            if (nextUrl) {
                this.iframeUrl.set(nextUrl);
                this.timeboxIframeLoad();
                this.iframeQueueService.clearQueueIn();
            }
        });

        this.listener = this.renderer.listen('window', 'message', (event) => {
            if (event?.data?.type === 'EUA_AUTHORIZE_RESPONSE') {
                this.iframeUrl.set('');
                this.changeDetectorRef.detectChanges();
                this.iframeQueueService.nextOut(event.data.payload);
            }
        });
    }

    private timeboxIframeLoad(): void {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }

        const timeoutTime = 15000;
        this.timeoutId = setTimeout(() => {
            if (this.iframeUrl()) {
                this.iframeUrl.set('');
                this.changeDetectorRef.detectChanges();
                this.iframeQueueService.nextOut('CALL_TIMEOUT');
            }
            this.timeoutId = null;
        }, timeoutTime);
    }
}
